import React, {useEffect, useState} from "react";
import BottomActionBar from "./BottomActionBar";
import mask2 from "../Accests/images/masks/masks.webp";
import mask3 from "../Accests/images/masks/Antic.jpg";
import mask4 from "../Accests/images/masks/antic1.jpg";

const Bank = () => {

    const images = [mask2,mask3,mask4];

    const [showActionBar, setShowActionBar] = useState(true);
    let lastScrollY = window.scrollY;

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setShowActionBar(currentScrollY < lastScrollY);
            lastScrollY = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <BottomActionBar visible={showActionBar}/>


        <section id="bank" className="bg-gradient-to-br from-yellow-50 to-white py-10 px-4 mt-24 md:mt-14 lg:mt-10 ">
            <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
                    Bank Details
                </h2>


                {/* Bank Card */}
                <div className="bg-white rounded-2xl shadow-lg p-6 border border-yellow-200">

                    <p className="text-gray-600"><strong>Account Holder:</strong> M.G.
                        Madushanka</p>
                    <p className="text-gray-600"><strong>Account Number:</strong></p>
                    <p className="text-gray-600"><strong>Bank:</strong> Sampath Bank</p>
                    <p className="text-gray-600"><strong>Branch:</strong> Ambalangoda</p>
                    <p className="text-gray-600"><strong>Swift code</strong> BSAMLKLX</p>
                    <p className="text-gray-600"><strong>Country:</strong> Sri Lanka</p>
                </div>

                {/* Highlighted Message */}
                <div
                    className="bg-yellow-100 border-l-4 border-yellow-400 text-yellow-800 p-4 rounded-lg shadow-md mt-10">
                    <p className="text-lg font-medium">
                        Dear Sir/Madam, to book all the tours of your choice, please deposit money into our bank account
                        and send the receipt to our WhatsApp number.
                    </p>
                </div>
            </div>
        </section>
        </>
    );
};

export default Bank;
